import { Pipe, PipeTransform } from '@angular/core';
import { RollForwardTable } from '../../classes/roll-forward-table';

@Pipe({
    name: 'selectionCount',
})
export class SelectionCountPipe implements PipeTransform {
    transform(value: RollForwardTable[], category: string): number {
        if (value == null) return null;

        let count: number;
        if (category === 'active') {
            count = value.filter(f => f.ActiveLastYear).length;
        }
        if (category === 'historicallyActive') {
            count = value.filter(f => f.HistoricallyActive).length;
        }
        if (category === 'notActive') {
            count = value.filter(f => f.NotActive).length;
        }

        return count;
    }
}
